import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { ArticleEnvironment } from '../environment';
import { RelevantArticlesIds } from '../entities';

export class RelevantArticlesRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).relevantUrl, session);
  }

  getRelevantArticles = (channelId?: number): SafePromise<RelevantArticlesIds> => {
    const url = this.URL(`api/articles/relevant`, {
      channel_id: channelId,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
    });
  };
}
